import base from './base'; // 导入接口域名列表
import axios from '@/utils/http'; // 导入http中创建的axios实例
/**
 * 公共api接口
 */
const commonApi = {
    //获取app_token
    getAppToken(params){
       return axios.post(`/api/getAppToken.do`,params);
    },
    //获取access_token,并把token存到本地中(因为本身已经在苍穹登录，这里前段就不需要再登录获取token了)
    logOn(){
        let appParams = {
            "appId": "mal",
            "appSecuret": "123456",
            "tenantid": "dev_biz_branch",
            "accountId": "1547711017130518545",
            "language": "zh_CN"
        };
        let params = {
            "user": "18819259235",
            "apptoken": "",
            "tenantid": "dev_biz_branch",
            "accountId": "1547711017130518545",
            "usertype": "Mobile"
        }
        this.getAppToken(appParams).then(response=>{
            const appToken = response.data.data.app_token;
            params.apptoken = appToken;
            console.log("response",response);
            axios.post(`/api/login.do`,params).then(accTokenResponse=>{
                let token = accTokenResponse.data.data.access_token
                localStorage.setItem("token",token);
                console.log("token",token);
            });
        });
    },

    test(){
        let params={
            "apiname":"categorys","methodname":"testMethod"
        }
        return axios.post(`${base.businessBase}`,params)
    }
};


export default commonApi;